import React from 'react';
import { FormattedMessage } from 'react-intl';
import { format } from '../../lib/money';

const ShareInfo = props => (
  <div className="split-info even-split h3 mr-1 mb-0 mb-2">
    <FormattedMessage
      id="shareInto.evenSplit.locked.yourShare"
      defaultMessage="Your share:"
    />
    {' '}
    <b>{format(props.share)}</b>
    {' '}
    <FormattedMessage
      id="shareInto.evenSplit.locked.orLess"
      defaultMessage="or less if more people join."
    />
  </div>
);

ShareInfo.defaultProps = {
  share: null,
};

export default ShareInfo;



// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/share-info.even-split.locked.js